<template>
  <div id="home" class="uk-box-shadow-small uk-margin-medium-top uk-margin-medium-bottom uk-margin-large-left uk-margin-large-right">

    <div class="uk-section uk-background-primary">

        <div class="uk-text-center uk-background-primary">
          <h1>Mrs. Kamau</h1>
        </div>
        <div class="uk-text-center">
          <p>Welcome! If you are a student in Mrs. Kamau's A202 Class, click the button to enter.</p>
          <button @click="login" class="uk-button uk-button-secondary uk-button-large uk-margin-auto">Enter A202 Classroom</button>
        </div>
      
    </div>

    <!-- <div class="uk-section uk-background-default uk-text-center">
      <div class="uk-width-1-2 uk-margin-auto">
        <p>
          Lorem ipsum dolor sit amet, consectetur adipiscing elit. Curabitur magna turpis, condimentum nec tellus 
          consectetur, maximus convallis lacus. Aenean rutrum urna ornare mi consequat ullamcorper. Quisque at 
          accumsan dolor. Proin nec velit sit amet ante pretium consectetur. Vestibulum egestas risus vel consectetur 
          congue. Vivamus ornare laoreet nisl, in efficitur risus facilisis in. 
        </p>
      </div>

      <router-link to="/contact" class="uk-button uk-button-default uk-button-large">Contact Me</router-link>

    </div> -->

    <footer class="uk-section uk-text-center uk-background-muted">
        &copy; 2020 Mrs. Kamau
    </footer>

  </div>
</template>

<script>
import { mapActions } from "vuex";

export default {
  name: "Home",
  components: {

  },
  methods: {
    ...mapActions(["loginAction"]),
    login() {
      console.log('calling login action');
      this.loginAction();
    }
  }
};
</script>
